var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhYoutubeFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8138 5.418C20.6742 5.648 21.352 6.32578 21.582 7.18622C22 8.74578 22 12 22 12C22 12 22 15.2542 21.582 16.8138C21.352 17.6742 20.6742 18.352 19.8138 18.582C18.2542 19 12 19 12 19C12 19 5.74578 19 4.18622 18.582C3.32578 18.352 2.648 17.6742 2.418 16.8138C2 15.2542 2 12 2 12C2 12 2 8.74578 2.418 7.18622C2.648 6.32578 3.32578 5.648 4.18622 5.418C5.74578 5 12 5 12 5C12 5 18.2542 5 19.8138 5.418ZM15.1955 12L9.99999 15V9L15.1955 12Z",
    fill: "#00182F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhYoutubeFilled);
export default __webpack_public_path__ + "static/media/fmh-youtube-filled.5f2d6cd1678b2d0079233606746fd5dd.svg";
export { ForwardRef as ReactComponent };